// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"735":"68cf956c","850":"947d25ff","919":"76901b23"}[chunkId] + ".chunk.js";
};